import React, {Component} from 'react'

import ImageViewer from '../../ui/ImageViewer.js'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'

import CategoriesPanel from "./EditItemDialog/CategoriesPanel"
import ShopPanel from "./EditItemDialog/ShopPanel"
import ImagePanel from './EditItemDialog/ImagePanel.js'

import SelectShopDialog from '../../shop/SelectShopDialog'

import ErrorMessageDialog from '../../ui/ErrorMessageDialog.js'

import {config} from "../../config"

import api from '../../api.js'
import DeleteImageDialog from './DeleteImageDialog.js'

/**
 * <EditItemDialog item onUpdateItem = {item} onCancel = {} />
 */

class EditItemDialog extends Component {

	constructor(props) {
		super(props)
		this.state = {
			name: "",
			code: "",
			categories: [],
			categoriesChanged: true,
			shops: [],
			shopsChanged: false,
			dialog: undefined,
			images: [],
			comment: String(this.props.item.comment || ''),
		}
  	  	this.fileInputRef = React.createRef();
	}

	readyToUpdate() {
		if (this.state.name === "") {
			return false
		}
		if (this.state.categoriesChanged) {
			return true
		}
		if (this.state.shopsChanged) {
			return true
		}
		if (this.state.name !== this.props.item.name) {
			return true
		}
		if (this.state.code !== this.props.item.code) {
			return true
		}
		if (this.state.comment != this.props.item.comment) {
			return true
		}
		return false
	}

	async componentDidMount() {
		
		let response = await api.inventory.image.list(this.props.item.id)
		
		this.setState({
			name: this.props.item.name,
			code: this.props.item.code,
			categories: this.props.item.categories,
			categoriesChanged: false,
			shops: global.structuredClone(this.props.item.shops),
			images: response.images,
		})

	}

	update = async () => {
		let response = await api.inventory.image.list(this.props.item.id)
		this.setState({
			images: response.images,
		})
	}

	render() {

		if (this.state.dialog) {
			return this.state.dialog
		}

		return <Dialog
			open = {true}
			scroll = "body"
			fullWidth={true}
		>

			<DialogTitle>
				Редактировать предмет
			</DialogTitle>

			<DialogContent style = {{display: "flex", gap: "10px", flexDirection: "column"}}>

				<CategoriesPanel
					title = "Категории"
					parent = {this}
					categories = {this.state.categories}
					onAttachCategory = {category => {
						this.state.categories.push(category)
						this.setState({
							categoriesChanged: true
						})
					}}
					onDetachCategory = {category => {
						this.setState({
							categoriesChanged: true,
							categories: this.state.categories.filter(c => c !== category),
						})
					}}
				/>

				<ShopPanel
					title = "Магазины"
					shops = {this.state.shops}
					onAttachShopClick = {() => {
						this.setState({
							dialog: <SelectShopDialog 
								hideNoShop
								hideShops = {this.state.shops}
								onSelectClick = {(shop) => {
									if (!shop) {
										return
									}
									this.setState({dialog: undefined}, () => {
										if (!this.state.shops.find(s => s.id === shop.id)) {
											this.state.shops.push(shop)
											this.setState({shops: this.state.shops, shopsChanged: true})
										}
									})
								}}
								onCancelClick = {() => {this.setState({dialog: undefined})}}
							/>
						})
					}}
					onDetachShopClick = {(shop) => {
						this.setState({
							shopsChanged: true,
							shops: this.state.shops.filter((s) => s.id !== shop.id)
						})
					}}
				/>				

				<TextField
					value = {this.state.name}
					label = "Название предмета"
					margin = "normal"
					onChange = {e => {this.setState({name: e.target.value})}}
				/>

				<TextField
					value = {this.state.code}
					label = "Поисковый код"
					margin = "normal"
					onChange = {e => {this.setState({code: e.target.value})}}
				/>

				<TextField
					label="Комментарий"
					multiline
					minRows={4}
					maxRows={10}
					fullWidth
					variant="outlined"
					placeholder="Введите текст..."
					value={this.state.comment}

					onChange={e=>{
						e.stopPropagation()
						this.setState({
							comment: e.target.value
						})
					}}
				/>

				<input 
					type="file"
					ref={this.fileInputRef}
					onChange={async (e) => {
						const file = e.target.files[0]
						if (file) {

							const formData = new FormData()
							formData.append('file', file)
							await fetch(
								`${config.imageApiHost}/api/image`,
								{
									method: "POST",
									body: formData,
								}
							)
								.then( response => {
									if (!response.ok) {
										throw new Error(`Ошибка: ${response.status}`);
									}
									return response.json();
								})
								.then(response => {
									api.inventory.image.attach(this.props.item.id, response.filename)
									 	.then(this.update)									
								})
								.catch(error => {
									this.setState({
										dialog: <ErrorMessageDialog 
											message={ <div>Не удалось загрузить файл изображения.<br/>Файл должен быть изображением.<br/>Размер файла не должен превышать 3Мб</div> }
											onClose={()=>{ this.setState({dialog: undefined}) }}
										/>
									})
								});
						}
					}}
					style={{ display: "none" }}
					accept=".jpg,.jpeg,.png"
				/>

				<ImagePanel
					images = { this.state.images }
					onAddImageClick = {() => { 
						this.fileInputRef.current.click()
					}}
					onImageDeleteClick = { (image) => {
						this.setState({
							dialog: <DeleteImageDialog
								onDeleteImage = { async () => {
									api.inventory.image.detach(image.id)
										.then(this.update)
										.then(() => {
											this.setState({
												dialog: undefined
											})
										})
								} }
								onCancel = { () => {
									this.setState({ dialog: undefined })
								} }
							/>
						})
					} }
				/>

			</DialogContent>

			<DialogActions>

				<Button
					disabled = {!this.readyToUpdate()}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onUpdateItem === "function") {
							this.props.onUpdateItem({
								id: this.props.item.id,
								name: this.state.name,
								code: this.state.code,
								categories: this.state.categories,
								shops: this.state.shops,
								comment: this.state.comment,
							})
						}
					}}
				>Обновить</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>

			</DialogActions>

		</Dialog>
	}
}

export default EditItemDialog
